var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news_center"},[_c('indexTitle',{attrs:{"english_title":"Documentary","chinese_title":"展覽紀實","page":"true"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }